import { render } from "./addnewrandomcolumn.vue?vue&type=template&id=049c5798&scoped=true"
import script from "./addnewrandomcolumn.js?vue&type=script&lang=js"
export * from "./addnewrandomcolumn.js?vue&type=script&lang=js"

import "./addnewrandomcolumn.vue?vue&type=style&index=0&id=049c5798&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049c5798"]])

export default __exports__